<template lang="html">
  <div>
    <div class="con_wrap">
      <h1 class="title" @click="backHome()"> 	&#60; 가이드</h1>
    </div>
    <h1 class="logo">
      <img src="../../../../assets/images/introMain/logo.png" alt="">
    </h1>
    <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
      <swiper-slide id="slide1">
        <div>
            <img class="slide1_img1" src="../../../../assets/images/introTest/board.png" alt="">
            <img class="slide1_img2" src="../../../../assets/images/introTest/teacher.png" alt="">
        </div>
            <p class="speech1">
                안녕 친구들~ <br>
                전 여러분들을 도와줄 능수 쌤이예요! <br>
                지금부터 <span>기출문제</span>에 대해 알려줄게요 :)
            </p>
      </swiper-slide>
      <swiper-slide id="slide2">
        <div>
            <img class="slide2_img1" src="../../../../assets/images/introTest/pg1.jpg" alt="">
            <img class="slide2_img2" src="../../../../assets/images/introTest/list.png" alt="">
            <img class="slide2_img3" src="../../../../assets/images/introTest/circle.gif" alt="">
        </div>
        <p class="speech2">
            일단 <span>풀고 싶은 문제</span>를 <span>선택</span> 해볼까요?
        </p>
      </swiper-slide>
      <swiper-slide id="slide3">
        <div>
            <img class="slide3_img1" src="../../../../assets/images/introTest/pg2.png" alt="">
            <img class="slide3_img2" src="../../../../assets/images/introTest/pg2_1.png" alt="">
            <img class="slide3_img3" src="../../../../assets/images/introTest/pg2_2.png" alt="">
        </div>
        <p class="speech3">
            모든 시험은 <span>한번만</span> 풀 수 있어요 :) <br>
            <span>시험 시작하기</span>를 누르면 시작!
        </p>
      </swiper-slide>
      <swiper-slide id="slide4">
        <div>
            <img class="slide4_img1" src="../../../../assets/images/introTest/pg3.png" alt="">
            <img class="slide4_img2" src="../../../../assets/images/introTest/btn.png" alt="">
            <img class="slide4_img3" src="../../../../assets/images/introTest/pg3_bg.png" alt="">
            <img class="slide4_img4" src="../../../../assets/images/introTest/alert.png" alt="">
            <img class="slide4_img5" src="../../../../assets/images/introTest/circle2.gif" alt="">
        </div>
        <p class="speech4">
            도중에 <span>그만두면</span> 다시 풀 수 없으니 조심!
        </p>
      </swiper-slide>
      <swiper-slide id="slide5">
        <div>
            <img class="result_img" src="../../../../assets/images/introTest/pg4.png" alt="">
        </div>
        <p class="speech5">
            시험이 끝나면 점수도 확인 할 수 있어요! <br>
            그럼 <span>시작</span>해 볼까요?

        </p>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"></div>
    <div class="skip">
        <p><a href="#">지금 풀러 가기</a></p>
    </div>
  </div>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script>

import '../../../../assets/css/intro/test/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'


export default {
  mounted() {
    $("#slide1").ready(function(){
      $(".slide1_img1").fadeIn();
      $(".slide1_img2").delay(300).fadeIn();
      $(".speech1").delay(600).fadeIn();
    })
  },
  methods: {
    backHome() {
      this.$router.push('/pages/intro-main')
    },
  },
    data() {
        return {
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable:true
                },
                on: {
                  slideChange: function(){
                    var currentIndex = this.realIndex;
                    switch(currentIndex) {
                      case 0 : $(".slide1_img1").fadeIn();
                                $(".slide1_img2").delay(300).fadeIn();
                                $(".speech1").delay(600).fadeIn();
                                $(".swiper-slide div img").not("#slide1 img").hide();
                                $(".swiper-slide p").not("#slide1 p").hide();
                                $(".slide2_img2").css("width" , "300px");
                                break;

                      case 1 : $(".slide2_img1").fadeIn();
                                $(".slide2_img2").fadeIn();
                                $(".speech2").delay(300).fadeIn();
                                $(".slide2_img2").delay(300).queue(function(){
                                  $(this).css({
                                    "width" : "350px",
                                    "transition" : "all 0.5s ease",
                                  }).dequeue();
                                })
                                var gifSource = $('.slide2_img3').attr('src');
                                    $('.slide2_img3').attr('src', "");
                                    $('.slide2_img3').attr('src', gifSource +"?"+new Date().getTime());

                                $(".slide2_img3").delay(1000).fadeIn();
                                $(".swiper-slide div img").not("#slide2 img").hide();
                                $(".swiper-slide p").not("#slide2 p").hide();
                                $(".slide3_img2").css("width" , "300px");
                                break;

                      case 2 : $(".slide3_img1").delay(300).fadeIn();
                                $(".speech3").delay(600).fadeIn();
                                $(".slide3_img2 , .slide3_img3").delay(300).fadeIn();
                                $(".slide3_img2").delay(300).queue(function(){
                                  $(".slide3_img2").css({
                                    "transition" : "all 0.5s ease",
                                    "width" : "350px",
                                  }).dequeue();
                                })
                                $(".swiper-slide div img").not("#slide3 img").hide();
                                $(".swiper-slide p").not("#slide3 p").hide();
                                $(".slide2_img2").css("width" , "300px");
                                break;

                      case 3 : $(".slide4_img1 , .slide4_img2").delay(300).fadeIn();
                                $(".speech4").delay(600).fadeIn();

                                var gifSource = $('.slide4_img5').attr('src');
                                    $('.slide4_img5').attr('src', "");
                                    $('.slide4_img5').attr('src', gifSource +"?"+new Date().getTime());

                                $(".slide4_img5").delay(1000).fadeIn();
                                $(".slide4_img3 , .slide4_img4").delay(1400).fadeIn(250);
                                $(".swiper-slide div img").not("#slide4 img").hide();
                                $(".swiper-slide p").not("#slide4 p").hide();
                                $(".slide3_img2").css("width" , "300px");
                                break;
                      case 4 : $(".result_img").delay(300).fadeIn();
                                $(".speech5").delay(600).fadeIn();
                                $(".swiper-slide div img").not("#slide5 img").hide();
                                $(".swiper-slide p").not("#slide5 p").hide();
                                break;
                      }
                   }
                }
             }
         }
    },
    components: {
        swiper,
        swiperSlide
    },
}
</script>

<style lang="css" scoped>
* {
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
}
p {
  color: black;
  font-family: 'Noto Sans KR', sans-serif;
}
.con_wrap {
  display: flex;
  position: fixed;
  width: 90%;
  margin: 0 auto;
  padding: 40px 15px;
  z-index: 5;
}
.title {
  font-size: 1.3em;
  color: #1E90FF;
}
.back {
  height: 45px;
  padding: 15px 0;
}
.back img {
  width: 30px;
}
.logo {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 80px;
  text-align: center;
  border-radius: 10px;
  box-shadow : 0 2px 4px 0 rgb(0 0 0 / 15%), 0 3px 10px 0 rgb(0 0 0 / 14%);
  z-index: 5;

}
.logo img {
  width: 150px;
  margin-top: 20px;
}
.swiper-slide {
    height: 100%;
    font-size: 18px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    position: relative;
}
.swiper-slide div img {
    position: absolute;
    width: 300px;
    left: 50%;
    top: 40%;
    transform: translate(-50% , -50%);
    display: none;
}
.swiper-slide p {
    font-weight: bold;
    text-align: center;
    display: none;
}
.swiper-slide p span {
    color: #1d9cd3;
}
.skip {
    position: absolute;
    width: 100%;
    height: 80px;
    background-color: #1d9cd3;
    left: 0;
    bottom: 0;
    z-index: 2;
}
.skip p {
    text-align: center;
    line-height: 80px;
    font-weight: bold;
    font-size: 1.3em;
}
.skip p a {
    text-decoration: none;
    color: white;
}

@media screen and (max-height:450px) {
    .logo {
      width: 20%;
      top: 5%;
    }
    .logo img {
        width: 100px;
        margin-top: 25px;
    }
    .swiper-slide {
        height: 100%;
        flex-direction: row;
        justify-content: space-around;

    }
    .slide2_img2 {
      max-width: 240px;
      trasition: all 1s ease;
    }
    .slide3_img2 {
      max-width: 250px;
      trasition: all 1s ease;
    }
    .swiper-slide div img {
        width: 200px;
        left: 25%;
    }
    .swiper-slide p {
        z-index: 10;
        margin-left: 100px;
        margin-bottom: 50px
    }
    .swiper-pagination {
      top: 75%;
    }
}
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300&display=swap');
</style>
